(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["anew-abo-box"] && !Shopify.designMode) return;
  try {
    (function () {
    function formatKr(amount) {
      return (Math.round(amount * 100) / 100).toLocaleString('da-DK', { maximumFractionDigits: 2 }) + ' kr.';
    }

    function formatKrDaily(amount) {
      return amount.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr.';
    }

    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    }

    function getCart() {
      return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); });
    }

    function updateCartIconCount() {
      getCart()
        .then(function (cart) {
          var bubble = document.getElementById('cart-icon-bubble');
          var countEl = bubble && bubble.querySelector('span');
          if (countEl) countEl.textContent = cart.item_count;
        })
        .catch(function () {});
    }

    // Sætter en rabatkode på kurven uden at fjerne eksisterende koder.
    function applyDiscountCode(code) {
      return getCart()
        .then(function (cart) {
          var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
          var already = codes.some(function (c) { return String(c).toUpperCase() === code.toUpperCase(); });
          if (already) return;
          codes.push(code);
          return fetch(root() + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: codes.join(',') })
          });
        })
        .then(function () {
          if (typeof window.upcartRefreshCart === 'function') return window.upcartRefreshCart();
        })
        .catch(function (err) {
          console.warn('[Anew abo-boks] Kunne ikke sætte rabatkoden ' + code, err);
        });
    }

    document.querySelectorAll('.anew-abo-box[data-abo-box="meta"]').forEach(function (box) {
      var configEl = box.querySelector('[data-abo-config]');
      if (!configEl) return;
      var config;
      try { config = JSON.parse(configEl.textContent); } catch (e) { console.error('[Anew abo-boks] Ugyldig config', e); return; }

      var cards = {};
      config.cards.forEach(function (c) { cards[c.key] = c; });
      var state = { selected: cards[config.defaultKey] ? config.defaultKey : config.cards[0].key };

      var cta = box.querySelector('[data-abo-cta]');
      var errorEl = box.querySelector('[data-abo-error]');
      var successEl = box.querySelector('[data-abo-success]');
      var successTimer = null;
      var topPriceAmount = document.querySelector('[data-abo-top-price-amount]');
      var topPriceSuffix = document.querySelector('[data-abo-top-price-suffix]');

      function getUpsell(key) {
        // Det valgte tilkøb for kortet - eller null, hvis det ikke er afkrydset.
        var card = cards[key];
        var row = box.querySelector('[data-abo-upsell="' + key + '"]');
        if (!card || !row || !card.upsells.length) return null;
        var checkbox = row.querySelector('[data-abo-upsell-checkbox]');
        if (!checkbox || !checkbox.checked) return null;
        return card.upsells[getUpsellIndex(key)] || null;
      }

      function getUpsellIndex(key) {
        var row = box.querySelector('[data-abo-upsell="' + key + '"]');
        var sel = row && row.querySelector('[data-abo-upsell-select]');
        return sel ? parseInt(sel.value, 10) || 0 : 0;
      }

      function monthly(card, upsell) {
        return (card.price + (upsell ? upsell.sale : 0)) / (card.months || 1);
      }

      function updateHeadPrices() {
        config.cards.forEach(function (card) {
          var el = box.querySelector('[data-abo-card-head-price="' + card.key + '"]');
          if (!el) return;
          el.textContent = card.sub ? formatKr(card.price) + ' / ' + card.months + ' md.' : formatKr(card.price);
        });
      }

      function updateUpsellPricing(key) {
        var card = cards[key];
        var row = box.querySelector('[data-abo-upsell="' + key + '"]');
        if (!card || !row || !card.upsells.length) return;
        var up = card.upsells[getUpsellIndex(key)];
        if (!up) return;
        row.querySelector('[data-abo-upsell-sale]').textContent = formatKr(up.sale);
        var strike = row.querySelector('[data-abo-upsell-strike]');
        strike.textContent = up.compare > up.sale ? formatKr(up.compare) : '';
      }

      function updateDailyPrices() {
        config.cards.forEach(function (card) {
          if (!card.sub) return;
          var el = box.querySelector('[data-abo-card="' + card.key + '"] [data-abo-daily-price]');
          if (!el) return;
          var m = monthly(card, getUpsell(card.key));
          el.textContent = formatKrDaily(Math.round((m / 30) * 10) / 10);
        });
      }

      function updateSaveBadges() {
        config.cards.forEach(function (card) {
          var el = box.querySelector('[data-abo-save="' + card.key + '"]');
          if (!el) return;
          var save = card.save || 0;
          if (card.gift) save += card.gift.value;
          var up = getUpsell(card.key);
          if (up && up.compare > up.sale) save += up.compare - up.sale;
          el.hidden = !(save > 0);
          el.textContent = 'Spar ' + formatKr(Math.round(save));
        });
      }

      function updateTopPrice() {
        if (!topPriceAmount) return;
        var card = cards[state.selected];
        var up = getUpsell(state.selected);
        if (card.sub) {
          topPriceAmount.textContent = formatKr(Math.round(monthly(card, up)));
          if (topPriceSuffix) topPriceSuffix.textContent = '/md. med abonnement';
        } else {
          topPriceAmount.textContent = formatKr(Math.round(card.price + (up ? up.sale : 0)));
          if (topPriceSuffix) topPriceSuffix.textContent = '';
        }
      }

      function updateAll() {
        updateDailyPrices();
        updateSaveBadges();
        updateTopPrice();
      }

      function selectCard(key) {
        state.selected = key;
        box.querySelectorAll('[data-abo-card]').forEach(function (el) {
          el.classList.toggle('abo-card--selected', el.getAttribute('data-abo-card') === key);
        });
        updateTopPrice();
      }

      box.querySelectorAll('[data-abo-card-toggle]').forEach(function (el) {
        el.addEventListener('click', function () {
          selectCard(el.getAttribute('data-abo-card-toggle'));
        });
      });

      box.querySelectorAll('[data-abo-upsell-select]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          updateUpsellPricing(sel.closest('[data-abo-upsell]').getAttribute('data-abo-upsell'));
          updateAll();
        });
      });

      // Mængdevalg på Engangskøb: skift kortets variant og pris. Har
      // tilkøbet lige så mange valg, følger det med.
      box.querySelectorAll('[data-abo-variant-select]').forEach(function (sel) {
        var key = sel.getAttribute('data-abo-variant-select');
        var card = cards[key];
        if (!card || !card.options || !card.options.length) return;
        function apply() {
          var idx = parseInt(sel.value, 10) || 0;
          var opt = card.options[idx];
          if (!opt) return;
          card.variantId = opt.variantId;
          card.price = opt.price;
          var row = box.querySelector('[data-abo-upsell="' + key + '"]');
          var upSel = row && row.querySelector('[data-abo-upsell-select]');
          if (upSel && card.upsells.length === card.options.length) {
            upSel.value = String(idx);
            updateUpsellPricing(key);
          }
          updateHeadPrices();
          updateAll();
        }
        sel.addEventListener('change', apply);
        apply();
      });

      box.querySelectorAll('[data-abo-upsell-checkbox]').forEach(function (cb) {
        cb.addEventListener('change', updateAll);
      });

      updateHeadPrices();
      config.cards.forEach(function (card) { updateUpsellPricing(card.key); });
      updateAll();

      cta.addEventListener('click', function () {
        errorEl.style.display = 'none';
        var card = cards[state.selected];
        if (!card || !card.variantId) {
          errorEl.style.display = 'block';
          return;
        }
        if (card.sub && !card.sellingPlanId) {
          console.warn('[Anew abo-boks] Kortet mangler abonnementsplan-ID.');
          errorEl.textContent = 'Abonnementet er ikke klar til køb endnu.';
          errorEl.style.display = 'block';
          return;
        }

        var items = [];
        var main = { id: card.variantId, quantity: 1 };
        if (card.sub) main.selling_plan = card.sellingPlanId;
        // Gaven tilføjes af kunden selv i kurven ("Tilføj til kurven"). Kortets
        // vare fortæller kurven, hvilken gave den giver ret til.
        if (card.gift) {
          main.properties = { _gave_variant: String(card.gift.variantId), _gave_handle: card.gift.handle || '', _gave_kode: card.gift.discountCode || '' };
        }
        items.push(main);

        var up = getUpsell(card.key);
        if (up) {
          var upItem = { id: up.variantId, quantity: 1 };
          if (up.sellingPlanId) upItem.selling_plan = up.sellingPlanId;
          // Tilkøbspris-varer (handle tilkob-...) hører til dette produkt.
          // Kurven fjerner dem, hvis produktet ikke længere er i kurven.
          else upItem.properties = { _tilkob: box.getAttribute('data-product-handle') || '' };
          items.push(upItem);
        }

        cta.disabled = true;
        fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart/add fejlede');
            return res.json();
          })
          .then(function () {
            if (up && up.discountCode) return applyDiscountCode(up.discountCode);
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            updateCartIconCount();
            if (successEl) {
              successEl.style.display = 'block';
              if (successTimer) clearTimeout(successTimer);
              successTimer = setTimeout(function () { successEl.style.display = 'none'; }, 4000);
            }
          })
          .catch(function (err) {
            console.error(err);
            errorEl.textContent = 'Der skete en fejl - prøv igen, eller kontakt os.';
            errorEl.style.display = 'block';
          })
          .finally(function () {
            cta.disabled = false;
          });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["backup-20261012-anew-mundtape-subscription-box"] && !Shopify.designMode) return;
  try {
    (function () {
    // Anew Mundtape - egne varianter. Samme variant bruges til både
    // Abonnement (med selling_plan) og Engangskøb (uden selling_plan).
    var SELF_VARIANTS = {
      1: '57165189448005',
      3: '57165189480773',
      6: '57165189513541'
    };
    var SELF_ONETIME_PRICES = { 1: 129, 3: 329, 6: 599 };

    // Delt Seal-plangruppe (samme plan-ID'er på både Mundtape og Næsetape).
    var SELLING_PLANS = {
      1: { price: 99, sellingPlanId: '690583208261' },
      3: { price: 269, sellingPlanId: '690111152453' },
      6: { price: 499, sellingPlanId: '690111185221' }
    };

    // Krydssalg: Anew Næsetape.
    var UPSELL_VARIANTS = {
      1: '57165124632901',
      3: '57165124665669',
      6: '57165124698437'
    };

    // Fallback-førpriser, hvis data-attributterne mod forventning skulle
    // mangle (f.eks. hvis upsell-produktet ikke findes) - bruges KUN som
    // sikkerhedsnet, ikke som den normale kilde.
    var UPSELL_STRIKE_FALLBACK = { 1: 129, 3: 329, 6: 599 };

    // Engangskøb-upsell: fast rabat i kr. pr. varighed. SKAL matche beløbet i
    // de tilsvarende Shopify-rabatkoder (UPSELL_DISCOUNT_CODES), som sættes på
    // kurven, når upsell'en lægges i kurven fra Engangskøb-kortet
    // (129 -> 109, 329 -> 279, 599 -> 509 kr.). Ændres beløbene, skal
    // rabatkoderne i Shopify admin opdateres tilsvarende.
    var UPSELL_ONETIME_DISCOUNT = { 1: 20, 3: 50, 6: 90 };
    var UPSELL_DISCOUNT_CODES = {
      1: 'TILKOB-NAESETAPE-1',
      3: 'TILKOB-NAESETAPE-3',
      6: 'TILKOB-NAESETAPE-6'
    };

    function formatKr(amount) {
      return amount.toLocaleString('da-DK') + ' kr.';
    }

    function formatKrDaily(amount) {
      return amount.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr.';
    }

    function updateCartIconCount() {
      var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart.js' : '/cart.js');
      fetch(cartUrl, { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (!bubble) return;
          var countEl = bubble.querySelector('span');
          if (countEl) countEl.textContent = cart.item_count;
        })
        .catch(function () {});
    }

    // NB: Selector-fejl rettet 2026-09-25 (jf. Theis' feedback "ingen af
    // knapperne virker") - Liquid-output baseret på sektionens id må ikke
    // bruges inde i et javascript-tag, da Liquid ikke bliver renderet der
    // (Shopifys egen dokumentation). Selector'en matchede derfor aldrig
    // boksen, og INGEN event listeners blev nogensinde sat op. Bruger nu
    // samme klasse-baserede selector som Breeze-boksen (.anew-abo-box).
    // Upsell-rabat på Engangskøb (2026-09-25, jf. Theis): Shopify kan ikke se,
    // hvor en vare er lagt i kurven fra, så rabatten ligger som skjulte
    // BXGY-rabatkoder (TILKOB-...) i Shopify med et fast kronebeløb pr. variant.
    // Koden sættes på kurven her, EFTER varerne er lagt i kurven, og KUN når
    // upsell'en er valgt på Engangskøb-kortet. Kunder der selv lægger begge
    // varer i kurven får derfor ikke rabatten. Eksisterende rabatkoder i
    // kurven bevares (cart/update.js erstatter ellers hele listen).
    function applyUpsellDiscount(code) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
          var already = codes.some(function (c) { return String(c).toUpperCase() === code.toUpperCase(); });
          if (already) return;
          codes.push(code);
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: codes.join(',') })
          });
        })
        .then(function () {
          // Upcart (kurv-skuffen) åbner og tegner kurven allerede ved
          // cart/add.js - FØR rabatkoden er sat. Tegn den derfor igen her,
          // så kunden ser den nedsatte pris med det samme.
          if (typeof window.upcartRefreshCart === 'function') return window.upcartRefreshCart();
        })
        .catch(function (err) {
          console.warn('[Anew abo-boks] Kunne ikke sætte upsell-rabatkoden ' + code, err);
        });
    }

    // Kun denne boks - ellers overskriver de andre abo-bokses JS (samlet i
    // snippet-scripts.js) hinandens priser, fx 129/99 kr. på Breeze (2026-10-02).
    document.querySelectorAll('.anew-abo-box[data-abo-box="mundtape"]').forEach(function (box) {
      var state = {
        selectedCard: 'subscription',
        subInterval: 1,
        onetimeInterval: 1
      };

      // Førpriserne (strike) læses her fra data-attributterne, som Liquid
      // har sat ud fra Næsetapes reelle, aktuelle variant-priser (2026-09-25,
      // jf. Theis' ønske "opdater upsell førpriser til at trække på de
      // reelle produkter, så man ikke manuelt skal opdatere dem i koden").
      // "onetime"-prisen er førprisen minus den faste rabat i
      // UPSELL_ONETIME_DISCOUNT (samme beløb som rabatkoden i kurven), og "abo"-prisen er den delte faste
      // Seal-abonnementspris fra SELLING_PLANS ovenfor - ingen af delene
      // er derfor længere hardkodede tal, der skal vedligeholdes manuelt.
      var UPSELL_DURATIONS = {};
      [1, 3, 6].forEach(function (duration) {
        var strike = parseInt(box.getAttribute('data-upsell-strike-' + duration), 10);
        if (!strike || isNaN(strike)) strike = UPSELL_STRIKE_FALLBACK[duration];
        UPSELL_DURATIONS[duration] = {
          strike: strike,
          abo: SELLING_PLANS[duration].price,
          onetime: Math.max(strike - UPSELL_ONETIME_DISCOUNT[duration], 0)
        };
      });

      var cta = box.querySelector('[data-abo-cta]');
      var errorEl = box.querySelector('[data-abo-error]');
      var successEl = box.querySelector('[data-abo-success]');
      var successTimer = null;
      var dailyPriceEl = box.querySelector('[data-abo-daily-price]');
      var topPriceAmount = document.querySelector('[data-abo-top-price-amount]');
      var topPriceSuffix = document.querySelector('[data-abo-top-price-suffix]');

      function currentInterval() {
        return state.selectedCard === 'subscription' ? state.subInterval : state.onetimeInterval;
      }

      function getSelectedVariantId() {
        return SELF_VARIANTS[currentInterval()];
      }

      function selectCard(name) {
        state.selectedCard = name;
        box.querySelectorAll('[data-abo-card]').forEach(function (card) {
          card.classList.toggle('abo-card--selected', card.getAttribute('data-abo-card') === name);
        });
        updateHeadPrices();
        updateUpsellPricing('subscription');
        updateUpsellPricing('onetime');
        updateCta();
        updateTopPrice();
        updateDailyPrice();
      }

      function updateHeadPrices() {
        var subHead = box.querySelector('[data-abo-card-head-price="subscription"]');
        if (subHead) subHead.textContent = formatKr(SELLING_PLANS[state.subInterval].price) + ' / ' + state.subInterval + ' md.';
        var onceHead = box.querySelector('[data-abo-card-head-price="onetime"]');
        if (onceHead) onceHead.textContent = formatKr(SELF_ONETIME_PRICES[state.onetimeInterval]);
      }

      // Fuld (urabatteret fordelt) pris for næsetape-tilvalget i det
      // ANGIVNE kort (subscription eller onetime), 0 hvis ikke afkrydset.
      function getUpsellAmount(scope) {
        var row = box.querySelector('[data-abo-upsell="' + scope + '"]');
        if (!row) return 0;
        var checkbox = row.querySelector('[data-abo-upsell-checkbox]');
        if (!checkbox || !checkbox.checked) return 0;
        var duration = parseInt(row.querySelector('[data-abo-upsell-duration]').value, 10);
        var data = UPSELL_DURATIONS[duration];
        if (!data) return 0;
        return scope === 'subscription' ? data.abo : data.onetime;
      }

      // Abonnementets månedspris - uden tilvalg er det blot periodeprisen
      // delt med intervallet. MED tilvalg lægges periodeprisen og
      // næsetape-tilvalgets fulde pris sammen og deles med intervallet,
      // så tilvalget kun tælles med "sin andel" af abonnementsperioden
      // (ligesom på Anew Breeze).
      function computeSubscriptionMonthly(interval, upsellAmount) {
        return (SELLING_PLANS[interval].price + upsellAmount) / interval;
      }

      function updateDailyPrice() {
        if (!dailyPriceEl) return;
        // Dagsprisen i tjeklisten sidder altid inde i Abonnement-kortet og
        // skal derfor altid regne med abonnementets EGET næsetape-tilvalg,
        // uanset om Engangskøb er det valgte kort.
        var monthlyTotal = computeSubscriptionMonthly(state.subInterval, getUpsellAmount('subscription'));
        var daily = Math.round((monthlyTotal / 30) * 10) / 10;
        dailyPriceEl.textContent = formatKrDaily(daily);
      }

      // Prisen øverst på siden (over de 4 USP'er) - kun på Abonnement-kortet
      // vises den som en månedspris (jf. Anew Breeze-siden og Theis'
      // feedback 2026-09-25). På Engangskøb vises den valgte periodes
      // faste pris i stedet.
      function updateTopPrice() {
        if (!topPriceAmount) return;
        var upsellAmount = getUpsellAmount(state.selectedCard);
        if (state.selectedCard === 'subscription') {
          var monthly = computeSubscriptionMonthly(state.subInterval, upsellAmount);
          topPriceAmount.textContent = formatKr(Math.round(monthly));
          topPriceSuffix.textContent = '/md. med abonnement';
        } else {
          topPriceAmount.textContent = formatKr(Math.round(SELF_ONETIME_PRICES[state.onetimeInterval] + upsellAmount));
          topPriceSuffix.textContent = '';
        }
      }

      function updateCta() {
        cta.textContent = 'Læg i indkøbskurv';
      }

      function updateUpsellPricing(scope) {
        var row = box.querySelector('[data-abo-upsell="' + scope + '"]');
        if (!row) return;
        var duration = parseInt(row.querySelector('[data-abo-upsell-duration]').value, 10);
        var data = UPSELL_DURATIONS[duration];
        if (!data) return;
        var salePrice = scope === 'subscription' ? data.abo : data.onetime;
        row.querySelector('[data-abo-upsell-sale]').textContent = formatKr(salePrice);
        row.querySelector('[data-abo-upsell-strike]').textContent = formatKr(data.strike);
      }

      box.querySelectorAll('[data-abo-card-toggle]').forEach(function (head) {
        head.addEventListener('click', function () {
          selectCard(head.getAttribute('data-abo-card-toggle'));
        });
      });

      box.querySelectorAll('[data-abo-interval-group] .abo-interval-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('[data-abo-interval-group]');
          var scope = group.getAttribute('data-abo-interval-group');
          group.querySelectorAll('.abo-interval-btn').forEach(function (b) {
            b.classList.remove('is-active');
          });
          btn.classList.add('is-active');
          var interval = parseInt(btn.getAttribute('data-interval'), 10);
          if (scope === 'subscription') {
            state.subInterval = interval;
          } else {
            state.onetimeInterval = interval;
          }

          var upsellDuration = box.querySelector('[data-abo-upsell="' + scope + '"] [data-abo-upsell-duration]');
          if (upsellDuration) {
            upsellDuration.value = String(interval);
            updateUpsellPricing(scope);
          }

          updateHeadPrices();
          updateDailyPrice();
          updateTopPrice();
        });
      });

      box.querySelectorAll('[data-abo-upsell-duration]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var scope = sel.closest('[data-abo-upsell]').getAttribute('data-abo-upsell');
          updateUpsellPricing(scope);
          updateDailyPrice();
          updateTopPrice();
        });
      });

      box.querySelectorAll('[data-abo-upsell-checkbox]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          updateDailyPrice();
          updateTopPrice();
        });
      });

      updateHeadPrices();
      updateCta();
      updateUpsellPricing('subscription');
      updateUpsellPricing('onetime');
      updateDailyPrice();
      updateTopPrice();

      cta.addEventListener('click', function () {
        errorEl.style.display = 'none';
        var interval = currentInterval();
        var mainVariantId = getSelectedVariantId();
        var items = [];
        var upsellDiscountCode = null;

        if (!mainVariantId) {
          errorEl.textContent = 'Der skete en fejl - prøv igen, eller kontakt os.';
          errorEl.style.display = 'block';
          return;
        }

        if (state.selectedCard === 'subscription') {
          var plan = SELLING_PLANS[interval];
          if (!plan.sellingPlanId) {
            errorEl.textContent = 'Abonnementet er ikke klar til køb endnu.';
            errorEl.style.display = 'block';
            return;
          }
          items.push({ id: mainVariantId, quantity: 1, selling_plan: plan.sellingPlanId });
        } else {
          items.push({ id: mainVariantId, quantity: 1 });
        }

        var upsellRow = box.querySelector('[data-abo-upsell="' + state.selectedCard + '"]');
        var upsellChecked = upsellRow && upsellRow.querySelector('[data-abo-upsell-checkbox]').checked;
        if (upsellChecked) {
          var upsellDuration = parseInt(upsellRow.querySelector('[data-abo-upsell-duration]').value, 10);
          var upsellVariantId = UPSELL_VARIANTS[upsellDuration];
          if (upsellVariantId) {
            var upsellItem = { id: upsellVariantId, quantity: 1 };
            if (state.selectedCard === 'subscription') {
              var upsellPlan = SELLING_PLANS[upsellDuration];
              if (upsellPlan && upsellPlan.sellingPlanId) {
                upsellItem.selling_plan = upsellPlan.sellingPlanId;
              }
            }
            items.push(upsellItem);
            if (state.selectedCard === 'onetime') {
              upsellDiscountCode = UPSELL_DISCOUNT_CODES[upsellDuration] || null;
            }
          }
        }

        cta.disabled = true;
        fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart/add fejlede');
            return res.json();
          })
          .then(function () {
            if (upsellDiscountCode) return applyUpsellDiscount(upsellDiscountCode);
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            updateCartIconCount();
            errorEl.style.display = 'none';
            if (successEl) {
              successEl.style.display = 'block';
              if (successTimer) clearTimeout(successTimer);
              successTimer = setTimeout(function () {
                successEl.style.display = 'none';
              }, 4000);
            }
          })
          .catch(function (err) {
            console.error(err);
            errorEl.style.display = 'block';
          })
          .finally(function () {
            cta.disabled = false;
          });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["backup-20261012-anew-naesetape-subscription-box"] && !Shopify.designMode) return;
  try {
    (function () {
    // Anew Næsetape - egne varianter. Samme variant bruges til både
    // Abonnement (med selling_plan) og Engangskøb (uden selling_plan).
    var SELF_VARIANTS = {
      1: '57165124632901',
      3: '57165124665669',
      6: '57165124698437'
    };
    var SELF_ONETIME_PRICES = { 1: 129, 3: 329, 6: 599 };

    // Delt Seal-plangruppe (samme plan-ID'er på både Mundtape og Næsetape).
    var SELLING_PLANS = {
      1: { price: 99, sellingPlanId: '690583208261' },
      3: { price: 269, sellingPlanId: '690111152453' },
      6: { price: 499, sellingPlanId: '690111185221' }
    };

    // Krydssalg: Anew Mundtape.
    var UPSELL_VARIANTS = {
      1: '57165189448005',
      3: '57165189480773',
      6: '57165189513541'
    };

    // Fallback-førpriser, hvis data-attributterne mod forventning skulle
    // mangle (f.eks. hvis upsell-produktet ikke findes) - bruges KUN som
    // sikkerhedsnet, ikke som den normale kilde.
    var UPSELL_STRIKE_FALLBACK = { 1: 129, 3: 329, 6: 599 };

    // Engangskøb-upsell: fast rabat i kr. pr. varighed. SKAL matche beløbet i
    // de tilsvarende Shopify-rabatkoder (UPSELL_DISCOUNT_CODES), som sættes på
    // kurven, når upsell'en lægges i kurven fra Engangskøb-kortet
    // (129 -> 109, 329 -> 279, 599 -> 509 kr.). Ændres beløbene, skal
    // rabatkoderne i Shopify admin opdateres tilsvarende.
    var UPSELL_ONETIME_DISCOUNT = { 1: 20, 3: 50, 6: 90 };
    var UPSELL_DISCOUNT_CODES = {
      1: 'TILKOB-MUNDTAPE-1',
      3: 'TILKOB-MUNDTAPE-3',
      6: 'TILKOB-MUNDTAPE-6'
    };

    function formatKr(amount) {
      return amount.toLocaleString('da-DK') + ' kr.';
    }

    function formatKrDaily(amount) {
      return amount.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr.';
    }

    function updateCartIconCount() {
      var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart.js' : '/cart.js');
      fetch(cartUrl, { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (!bubble) return;
          var countEl = bubble.querySelector('span');
          if (countEl) countEl.textContent = cart.item_count;
        })
        .catch(function () {});
    }

    // NB: Selector-fejl rettet 2026-09-25 (jf. Theis' feedback "ingen af
    // knapperne virker") - Liquid-output baseret på sektionens id må ikke
    // bruges inde i et javascript-tag, da Liquid ikke bliver renderet der
    // (Shopifys egen dokumentation). Selector'en matchede derfor aldrig
    // boksen, og INGEN event listeners blev nogensinde sat op. Bruger nu
    // samme klasse-baserede selector som Breeze-boksen (.anew-abo-box).
    // Upsell-rabat på Engangskøb (2026-09-25, jf. Theis): Shopify kan ikke se,
    // hvor en vare er lagt i kurven fra, så rabatten ligger som skjulte
    // BXGY-rabatkoder (TILKOB-...) i Shopify med et fast kronebeløb pr. variant.
    // Koden sættes på kurven her, EFTER varerne er lagt i kurven, og KUN når
    // upsell'en er valgt på Engangskøb-kortet. Kunder der selv lægger begge
    // varer i kurven får derfor ikke rabatten. Eksisterende rabatkoder i
    // kurven bevares (cart/update.js erstatter ellers hele listen).
    function applyUpsellDiscount(code) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
          var already = codes.some(function (c) { return String(c).toUpperCase() === code.toUpperCase(); });
          if (already) return;
          codes.push(code);
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ discount: codes.join(',') })
          });
        })
        .then(function () {
          // Upcart (kurv-skuffen) åbner og tegner kurven allerede ved
          // cart/add.js - FØR rabatkoden er sat. Tegn den derfor igen her,
          // så kunden ser den nedsatte pris med det samme.
          if (typeof window.upcartRefreshCart === 'function') return window.upcartRefreshCart();
        })
        .catch(function (err) {
          console.warn('[Anew abo-boks] Kunne ikke sætte upsell-rabatkoden ' + code, err);
        });
    }

    // Kun denne boks - ellers overskriver de andre abo-bokses JS (samlet i
    // snippet-scripts.js) hinandens priser, fx 129/99 kr. på Breeze (2026-10-02).
    document.querySelectorAll('.anew-abo-box[data-abo-box="naesetape"]').forEach(function (box) {
      var state = {
        selectedCard: 'subscription',
        subInterval: 1,
        onetimeInterval: 1
      };

      // Førpriserne (strike) læses her fra data-attributterne, som Liquid
      // har sat ud fra Mundtapes reelle, aktuelle variant-priser (2026-09-25,
      // jf. Theis' ønske "opdater upsell førpriser til at trække på de
      // reelle produkter, så man ikke manuelt skal opdatere dem i koden").
      // "onetime"-prisen er førprisen minus den faste rabat i
      // UPSELL_ONETIME_DISCOUNT (samme beløb som rabatkoden i kurven), og "abo"-prisen er den delte faste
      // Seal-abonnementspris fra SELLING_PLANS ovenfor - ingen af delene
      // er derfor længere hardkodede tal, der skal vedligeholdes manuelt.
      var UPSELL_DURATIONS = {};
      [1, 3, 6].forEach(function (duration) {
        var strike = parseInt(box.getAttribute('data-upsell-strike-' + duration), 10);
        if (!strike || isNaN(strike)) strike = UPSELL_STRIKE_FALLBACK[duration];
        UPSELL_DURATIONS[duration] = {
          strike: strike,
          abo: SELLING_PLANS[duration].price,
          onetime: Math.max(strike - UPSELL_ONETIME_DISCOUNT[duration], 0)
        };
      });

      var cta = box.querySelector('[data-abo-cta]');
      var errorEl = box.querySelector('[data-abo-error]');
      var successEl = box.querySelector('[data-abo-success]');
      var successTimer = null;
      var dailyPriceEl = box.querySelector('[data-abo-daily-price]');
      var topPriceAmount = document.querySelector('[data-abo-top-price-amount]');
      var topPriceSuffix = document.querySelector('[data-abo-top-price-suffix]');

      function currentInterval() {
        return state.selectedCard === 'subscription' ? state.subInterval : state.onetimeInterval;
      }

      function getSelectedVariantId() {
        return SELF_VARIANTS[currentInterval()];
      }

      function selectCard(name) {
        state.selectedCard = name;
        box.querySelectorAll('[data-abo-card]').forEach(function (card) {
          card.classList.toggle('abo-card--selected', card.getAttribute('data-abo-card') === name);
        });
        updateHeadPrices();
        updateUpsellPricing('subscription');
        updateUpsellPricing('onetime');
        updateCta();
        updateTopPrice();
        updateDailyPrice();
      }

      function updateHeadPrices() {
        var subHead = box.querySelector('[data-abo-card-head-price="subscription"]');
        if (subHead) subHead.textContent = formatKr(SELLING_PLANS[state.subInterval].price) + ' / ' + state.subInterval + ' md.';
        var onceHead = box.querySelector('[data-abo-card-head-price="onetime"]');
        if (onceHead) onceHead.textContent = formatKr(SELF_ONETIME_PRICES[state.onetimeInterval]);
      }

      // Fuld (urabatteret fordelt) pris for mundtape-tilvalget i det
      // ANGIVNE kort (subscription eller onetime), 0 hvis ikke afkrydset.
      function getUpsellAmount(scope) {
        var row = box.querySelector('[data-abo-upsell="' + scope + '"]');
        if (!row) return 0;
        var checkbox = row.querySelector('[data-abo-upsell-checkbox]');
        if (!checkbox || !checkbox.checked) return 0;
        var duration = parseInt(row.querySelector('[data-abo-upsell-duration]').value, 10);
        var data = UPSELL_DURATIONS[duration];
        if (!data) return 0;
        return scope === 'subscription' ? data.abo : data.onetime;
      }

      // Abonnementets månedspris - uden tilvalg er det blot periodeprisen
      // delt med intervallet. MED tilvalg lægges periodeprisen og
      // mundtape-tilvalgets fulde pris sammen og deles med intervallet,
      // så tilvalget kun tælles med "sin andel" af abonnementsperioden
      // (ligesom på Anew Breeze).
      function computeSubscriptionMonthly(interval, upsellAmount) {
        return (SELLING_PLANS[interval].price + upsellAmount) / interval;
      }

      function updateDailyPrice() {
        if (!dailyPriceEl) return;
        // Dagsprisen i tjeklisten sidder altid inde i Abonnement-kortet og
        // skal derfor altid regne med abonnementets EGET mundtape-tilvalg,
        // uanset om Engangskøb er det valgte kort.
        var monthlyTotal = computeSubscriptionMonthly(state.subInterval, getUpsellAmount('subscription'));
        var daily = Math.round((monthlyTotal / 30) * 10) / 10;
        dailyPriceEl.textContent = formatKrDaily(daily);
      }

      // Prisen øverst på siden (over de 4 USP'er) - kun på Abonnement-kortet
      // vises den som en månedspris (jf. Anew Breeze-siden og Theis'
      // feedback 2026-09-25). På Engangskøb vises den valgte periodes
      // faste pris i stedet.
      function updateTopPrice() {
        if (!topPriceAmount) return;
        var upsellAmount = getUpsellAmount(state.selectedCard);
        if (state.selectedCard === 'subscription') {
          var monthly = computeSubscriptionMonthly(state.subInterval, upsellAmount);
          topPriceAmount.textContent = formatKr(Math.round(monthly));
          topPriceSuffix.textContent = '/md. med abonnement';
        } else {
          topPriceAmount.textContent = formatKr(Math.round(SELF_ONETIME_PRICES[state.onetimeInterval] + upsellAmount));
          topPriceSuffix.textContent = '';
        }
      }

      function updateCta() {
        cta.textContent = 'Læg i indkøbskurv';
      }

      function updateUpsellPricing(scope) {
        var row = box.querySelector('[data-abo-upsell="' + scope + '"]');
        if (!row) return;
        var duration = parseInt(row.querySelector('[data-abo-upsell-duration]').value, 10);
        var data = UPSELL_DURATIONS[duration];
        if (!data) return;
        var salePrice = scope === 'subscription' ? data.abo : data.onetime;
        row.querySelector('[data-abo-upsell-sale]').textContent = formatKr(salePrice);
        row.querySelector('[data-abo-upsell-strike]').textContent = formatKr(data.strike);
      }

      box.querySelectorAll('[data-abo-card-toggle]').forEach(function (head) {
        head.addEventListener('click', function () {
          selectCard(head.getAttribute('data-abo-card-toggle'));
        });
      });

      box.querySelectorAll('[data-abo-interval-group] .abo-interval-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('[data-abo-interval-group]');
          var scope = group.getAttribute('data-abo-interval-group');
          group.querySelectorAll('.abo-interval-btn').forEach(function (b) {
            b.classList.remove('is-active');
          });
          btn.classList.add('is-active');
          var interval = parseInt(btn.getAttribute('data-interval'), 10);
          if (scope === 'subscription') {
            state.subInterval = interval;
          } else {
            state.onetimeInterval = interval;
          }

          var upsellDuration = box.querySelector('[data-abo-upsell="' + scope + '"] [data-abo-upsell-duration]');
          if (upsellDuration) {
            upsellDuration.value = String(interval);
            updateUpsellPricing(scope);
          }

          updateHeadPrices();
          updateDailyPrice();
          updateTopPrice();
        });
      });

      box.querySelectorAll('[data-abo-upsell-duration]').forEach(function (sel) {
        sel.addEventListener('change', function () {
          var scope = sel.closest('[data-abo-upsell]').getAttribute('data-abo-upsell');
          updateUpsellPricing(scope);
          updateDailyPrice();
          updateTopPrice();
        });
      });

      box.querySelectorAll('[data-abo-upsell-checkbox]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          updateDailyPrice();
          updateTopPrice();
        });
      });

      updateHeadPrices();
      updateCta();
      updateUpsellPricing('subscription');
      updateUpsellPricing('onetime');
      updateDailyPrice();
      updateTopPrice();

      cta.addEventListener('click', function () {
        errorEl.style.display = 'none';
        var interval = currentInterval();
        var mainVariantId = getSelectedVariantId();
        var items = [];
        var upsellDiscountCode = null;

        if (!mainVariantId) {
          errorEl.textContent = 'Der skete en fejl - prøv igen, eller kontakt os.';
          errorEl.style.display = 'block';
          return;
        }

        if (state.selectedCard === 'subscription') {
          var plan = SELLING_PLANS[interval];
          if (!plan.sellingPlanId) {
            errorEl.textContent = 'Abonnementet er ikke klar til køb endnu.';
            errorEl.style.display = 'block';
            return;
          }
          items.push({ id: mainVariantId, quantity: 1, selling_plan: plan.sellingPlanId });
        } else {
          items.push({ id: mainVariantId, quantity: 1 });
        }

        var upsellRow = box.querySelector('[data-abo-upsell="' + state.selectedCard + '"]');
        var upsellChecked = upsellRow && upsellRow.querySelector('[data-abo-upsell-checkbox]').checked;
        if (upsellChecked) {
          var upsellDuration = parseInt(upsellRow.querySelector('[data-abo-upsell-duration]').value, 10);
          var upsellVariantId = UPSELL_VARIANTS[upsellDuration];
          if (upsellVariantId) {
            var upsellItem = { id: upsellVariantId, quantity: 1 };
            if (state.selectedCard === 'subscription') {
              var upsellPlan = SELLING_PLANS[upsellDuration];
              if (upsellPlan && upsellPlan.sellingPlanId) {
                upsellItem.selling_plan = upsellPlan.sellingPlanId;
              }
            }
            items.push(upsellItem);
            if (state.selectedCard === 'onetime') {
              upsellDiscountCode = UPSELL_DISCOUNT_CODES[upsellDuration] || null;
            }
          }
        }

        cta.disabled = true;
        fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart/add fejlede');
            return res.json();
          })
          .then(function () {
            if (upsellDiscountCode) return applyUpsellDiscount(upsellDiscountCode);
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            updateCartIconCount();
            errorEl.style.display = 'none';
            if (successEl) {
              successEl.style.display = 'block';
              if (successTimer) clearTimeout(successTimer);
              successTimer = setTimeout(function () {
                successEl.style.display = 'none';
              }, 4000);
            }
          })
          .catch(function (err) {
            console.error(err);
            errorEl.style.display = 'block';
          })
          .finally(function () {
            cta.disabled = false;
          });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
